import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { languageValidationParameter } from '../constants';
import { DashboardItem, DashboardItemValidation } from '../types-store';

export const validateDashboard = (
  dashboard: DashboardItem,
  languageOptions: ComplexValue<number>[],
  validationErrorMessage: string
): DashboardItemValidation => {

  const allLanguages = (languageOptions || [])
    .map(option => (dashboard && dashboard.language || [])
      .find(language => language.value === option.value)
      || { value: option.value }
    );

  const languageValidation = allLanguages
    .map(language =>
      language.description === undefined || language.description.trim() === ''
        ? {
          level: ValidationLevel.error,
          message: validationErrorMessage,
          parameters: {
            [languageValidationParameter]: language.value
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const accessTypeValidation = !isDefinedIncludingZero(dashboard?.accessType?.value)
    ? {
      level: ValidationLevel.error,
      message: validationErrorMessage
    }
    : undefined;

  return {
    ...(languageValidation.length > 0 && {
      language: {
        level: ValidationLevel.error,
        messages: languageValidation
      }
    }),
    ...(!!accessTypeValidation && {
      accessType: {
        level: ValidationLevel.error,
        messages: [accessTypeValidation]
      }
    })
  };
};
